import { connect } from 'react-redux';
import SelectEmployerDepartment from './SelectEmployerDepartment';
import { clearSession, setSelectEmployer, setSelectEmployerDepartment } from '../../actions/session';

const mapStateToProps = state => ({
  user: state.session.user,
  userIdentified: state.session.userIdentified,
  selectedEmployer: state.session.selectedEmployer
});
const mapDispatchToProps = dispatch => ({
  selectEmployerDepartment(actionPayload) {
    dispatch(setSelectEmployerDepartment)(actionPayload);
  },
  selectEmployer(actionPayload) {
    dispatch(setSelectEmployer)(actionPayload);
  },
  logout: dispatch(clearSession)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectEmployerDepartment);



// WEBPACK FOOTER //
// ./src/containers/SelectEmployerDepartment/index.js